import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getUserById, logoutApi } from '../features/authSlice';
import AddTechnicianModal from './AddTechnicianModal';
import icoHamburger from '../assets/images/ico_hamburger.svg';
import userProfileLogo from '../assets/images/user_profile.svg';
import plusIcon from '../assets/images/plus_icon.svg';
import logoutIcon from '../assets/images/log_out_icon.svg'; // Use your provided logout icon
import editIcon from '../assets/images/Edit.svg'; // Use an edit icon (update filename if needed)
import userArrow from '../assets/images/user_arrow.svg';
import arrowLeft from '../assets/images/arrow-left.svg';
import '../styles/layout.css';
import '../styles/header.css';

const Header = ({ title = 'Dashboard', onAddTechnician, onHamburger }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [profileUser, setProfileUser] = useState(undefined);
  const [profileName, setProfileName] = useState(undefined);
  const dispatch = useDispatch();
  const menuRef = useRef(null);

  useEffect(() => {
    const fetchUser = async () => {
      const userId = localStorage.getItem('userId');
      if (userId) {
        const resultAction = await dispatch(getUserById(userId));
        if (getUserById.fulfilled.match(resultAction)) {
          setProfileUser(resultAction.payload);
          setProfileName(resultAction.payload.firstname + ' ' + resultAction.payload.lastname);
        } else {
          setProfileUser(undefined);
        }
      } else {
        setProfileUser(undefined);
      }
    };
    fetchUser();
  }, [profileModalOpen]);


  const handleProfile = async () => {
    setMenuOpen(false);
    // const userId = localStorage.getItem('userId');
    // if (userId) {
    //   const resultAction = await dispatch(getUserById(userId));
    //   if (getUserById.fulfilled.match(resultAction)) {
    //     setProfileUser(resultAction.payload);
    //   } else {
    //     setProfileUser(undefined);
    //   }
    // } else {
    //   setProfileUser(undefined);
    // }
    setProfileModalOpen(true);
  };

  const handleSignout = async () => {
    setMenuOpen(false);
    try {
      await dispatch(logoutApi());
      localStorage.clear();
      navigate('/login');
    } catch (e) {
      console.error('Logout failed', e);
    }

  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="header-wrapper">
        <div className="header-left">
          <div className="ico-hamburger hamburger-menu">
            <img src={icoHamburger} alt="Hamburger Menu" onClick={onHamburger} />
          </div>
          {title !== "Dashboard" && title !== "Technicians" && (
            <div className="ico-hamburger" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
              <img src={arrowLeft} alt="Back" />
            </div>
          )}
          <h2>{title}</h2>
        </div>
        <div className="header-right">
          {title === 'Technicians' && (
            <button className="add-technician-btn" onClick={onAddTechnician}>
              <img src={plusIcon} alt="plus" className="plus" />
              Add Technician
            </button>
          )}
          <div className="user-btn" ref={menuRef}>
            <div
              className="user-btn-trigger"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <img src={userProfileLogo} alt="User Profile" />
              <span>{profileName ?? 'Users'}</span>
              <img src={userArrow} alt="Dropdown Arrow" />
            </div>

            <div className={`user-btn-dropdown ${menuOpen ? "open" : ""}`}>
              <ul>
                <li onClick={handleProfile}>
                  <a href="#">
                    <img src={editIcon} alt="Edit Profile" />
                    Update Profile
                  </a>
                </li>
                <li onClick={handleSignout}>
                  <a href="#">
                    <img src={logoutIcon} alt="Sign Out" />
                    Sign Out
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="user-btn" ref={menuRef}>
            <div
              className="user-btn-trigger"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <img src={userProfileLogo} alt="User Profile" />
              <span>Users</span>
              <img src={userArrow} alt="Dropdown Arrow" />
            </div>
            {menuOpen && (
              <div className="user-btn-dropdown">
                <ul>
                  <li onClick={handleProfile}>
                    <a href="#">
                      <img
                        src={editIcon}
                        alt="Edit Profile"
                      />
                      Update Profile
                    </a>
                  </li>
                  <li onClick={handleSignout}>
                    <a href="#">
                      <img src={logoutIcon} alt="Sign Out" />
                      Sign Out
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div> */}
        </div>
      </div>
      {title === 'Technicians' && (
        <button className="add-technician-btn responsive" onClick={onAddTechnician}>
          <img src={plusIcon} alt="plus" className="plus" />
          Add Technician
        </button>
      )}
      <AddTechnicianModal
        open={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
        editMode={true}
        customTitle="Update Profile"
        user={profileUser}
      />
    </div>
  );
};

export default Header;
